<div class="custom-control custom-checkbox">

  <input
    type="checkbox"
    class="custom-control-input"
    [id]="uniqueId"
    [formControl]="inputFormControl"
    (blur)="onInputBlur()"
  >

  <label class="custom-control-label" [ngStyle]="{'pointer-events': (isReport===false) ? 'all' : 'none'}" style="padding-top:2px" [attr.for]="uniqueId">{{caption}}</label>
  <!--<span style="font-size:9px;color:red">{{uniqueId}}</span>-->

  <div *ngIf="popup!=null && popup!==''" class="scg-inline-popup">
    <app-info-popup
      [isWarning]="isWarningPopup">
      {{popup}}
    </app-info-popup>
  </div>

</div>
